import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';

import { Input, Autocomplete, Select, Checkbox } from '~/components/Form';

import {
  storeCadastroTerminal,
  updateCadastroTerminal,
} from '~/store/modules/cadastroterminal/actions';

import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';

import { t, validCharacters } from '~/helpers';

import { Container } from './styles';

import { closeDialog } from '~/store/modules/dialog/actions';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const [fecharForm, setFecharForm] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [valuePosto, setValuePosto] = React.useState(0);
  const [inputValuePosto, setInputValuePosto] = React.useState('');

  const [term_controla_cbcC, setTerm_controla_cbcC] = useState(false);
  const [TERMCONTROLACBC, setTERMCONTROLACBC] = useState(false);
  
  const [term_controla_lcC, setTerm_controla_lcC] = useState(false);
  const [TERMCONTROLALC, setTERMCONTROLALC] = useState(false);
  

  const { loading, find, params } = useSelector(
    (state) => state.cadastroterminal
  );
  const initials = create ? data : { ...find, ...data };

  async function handleSubmit(param) {

    try {


      const schema = Yup.object().shape({
        poco_codigo: create
          ? Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10))
            .test(
              'characters-invalid',
              t('s.configuracao.geral.naopodecontercaracterespecial'),
              function (value) {
                return validCharacters(value);
              }
            )
            .nullable()
          : Yup.string(),

        term_descricao: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(30, t('s.geral.validacao.tamanhomaximo').replace('%s', 30))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            function (value) {
              return validCharacters(value);
            }
          ),

        term_identificacao: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(10, t('s.geral.validacao.tamanhomaximo').replace('%s', 10))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            function (value) {
              return validCharacters(value);
            }
          ),

        term_ip: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(15, t('s.geral.validacao.tamanhomaximo').replace('%s', 15))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            function (value) {
              return validCharacters(value);
            }
          ),

        term_codigo_seguranca: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, t('s.geral.validacao.campoobrigatorio').replace('%s', 1))
          .max(999, t('s.geral.validacao.tamanhomaximo').replace('%s', 999)),

        term_porta: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, t('s.geral.validacao.campoobrigatorio').replace('%s', 1))
          .max(9999, t('s.geral.validacao.tamanhomaximo').replace('%s', 9999)),

        term_versao_firmware: Yup.string().required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, t('s.geral.validacao.campoobrigatorio').replace('%s', 1))
          .nullable()
        ,

        term_status: Yup.string().required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, t('s.geral.validacao.campoobrigatorio').replace('%s', 1))
          .nullable()
        ,

      });

      await schema.validate(param, {
        abortEarly: false,
      });
    

      const objSend = {
        term_identificacao: param.term_identificacao,
        poco_codigo: param.poco_codigo,
        term_descricao: param.term_descricao,
        term_ip: param.term_ip,
        term_ult_tent_conexao: param.term_ult_tent_conexao,
        term_ult_conexao: param.term_ult_conexao,
        term_status: param.term_status,
        term_codigo_seguranca: param.term_codigo_seguranca,
        term_maior_intervalo_dia: param.term_maior_intervalo_dia,
        term_versao_firmware: param.term_versao_firmware,
        term_porta: param.term_porta,
        
        term_ip_cbc: term_controla_cbcC ? param.term_ip_cbc : '',
        term_porta_cbc: term_controla_cbcC ? param.term_porta_cbc : '',
        
        term_ip_lc: term_controla_lcC  ? param.term_ip_lc : '',
        term_porta_lc: term_controla_lcC  ? param.term_porta_lc : '',
        term_end_rs485: term_controla_lcC  ? param.term_end_rs485 : '',
        
        term_controla_cbc: term_controla_cbcC ? 'S' : 'N', //param.term_controla_cbc,
        term_controla_lc: term_controla_lcC  ? 'S' : 'N', //param.term_controla_lc
      };

      if (create) {
        await dispatch(storeCadastroTerminal(objSend, params));
      } else {
        await dispatch(updateCadastroTerminal(objSend, params));
      }


    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (!loading) {

        const {
          term_controla_lc,
          term_controla_cbc,          
        } = find;

        if (term_controla_lc && term_controla_lc === 'S') {
          setTERMCONTROLALC(true);
          setTerm_controla_lcC(true);
        }

        if (term_controla_cbc && term_controla_cbc === 'S') {
          setTERMCONTROLACBC(true);
          setTerm_controla_cbcC(true);
        }


      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [find]);


  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (!loading) {
        reference.current.setData(initials);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [loading]);

  const statusSimNao = [
    { label: 'Não', value: 'N', },
    { label: 'Sim', value: 'S', },
  ];

  const vercasoFirmWare = [
    { label: 'PADRAO', value: 'PADRAO', },
    { label: 'PLACAMERCOSUL', value: 'PLACAMERCOSUL', },
    { label: 'PLACAMERCOSULLIB01012020', value: 'PLACAMERCOSULLIB01012020', },
  ];


  return (
    <Container>

      {isLoading ?
        <div style={{ zIndex: 999999 }}>
          <Spinner loading />
        </div> : ''
      }

      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (<>
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>

          <Autocomplete
            name="poco_codigo"
            label="poco_desc_abrev"
            title="Posto"
            id="poco_codigo"
            url="postoscomboios"
            unique="poco_codigo"
            disabled={!create}

            defaultValue=""
            hiddens={[{ name: 'poco_desc_abrev' }]}
            getValue={(value) => {
              if (value.poco_codigo !== null) {
                setValuePosto(value.poco_codigo);
              } else {
                setValuePosto(0);
              }
            }}
          />


          <Input
            name="term_descricao"
            label="Descrição"
          />
          <Input
            name="term_identificacao"
            label="Identificação"
            disabled={!create}
          />
          <Input
            name="term_ip"
            label="IP"
          />
          <Input
            name="term_codigo_seguranca"
            label="Código Segurança"
          />
          <Input
            name="term_porta"
            label="Porta"
          />

          <Select
            name="term_versao_firmware"
            label='Versão Firmware'
            options={vercasoFirmWare}
          //defaultValue={initials.poco_recebe_transf || 'N'}
          />

          <Select
            name="term_status"
            variant="outlined"
            label="Status"
            options={[
              { value: 1, label: 'Liberado' },
              { value: 2, label: 'Bloqueado' },
              { value: 3, label: 'Cancelado' },
            ]}
          />

          <Checkbox
            name="term_controla_cbc"
            label="Controla CBC"
            getValue={(value) => {
              setTerm_controla_cbcC(value);
              setTERMCONTROLACBC(value);
            }}
          />
          <Input
            name="term_ip_cbc"
            label="IP CBC"
            disabled={!TERMCONTROLACBC}
          />
          <Input
            name="term_porta_cbc"
            label="Porta CBC"
            disabled={!TERMCONTROLACBC}
          />

          <Checkbox
            name="term_controla_lc"
            label="Controla LC"
            getValue={(value) => {
              setTerm_controla_lcC(value);
              setTERMCONTROLALC(value);
            }}
          />
          <Input
            name="term_ip_lc"
            label="IP LC"
            disabled={!TERMCONTROLALC}
          />          
          <Input
            name="term_porta_lc"
            label="Porta LC"
            disabled={!TERMCONTROLALC}
          />
          <Input
            name="term_end_rs485"
            label="End. RS485"
            disabled={!TERMCONTROLALC}
          />



        </Form>
      </>
        )}


    </Container>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
